import React from 'react';
import { Route } from 'react-router-dom';
import AttendanceSettings from '@/pages/settings/AttendanceSettings';
import TenantPaymentGateway from '@/pages/settings/TenantPaymentGateway';
import SMSSettings from '@/pages/settings/SMSSettings';
import WhatsAppSettings from '@/pages/settings/WhatsAppSettings';
import CollegeSettings from '@/pages/settings/CollegeSettings';
import WithdrawalPolicySettings from '@/pages/settings/WithdrawalPolicySettings';
import DataMigration from '@/pages/settings/DataMigration';
import EmailSettings from '@/pages/admin/EmailSettings';
import DataResetPage from '@/pages/admin/DataResetPage';
import TimezoneSettings from '@/pages/settings/TimezoneSettings';
import CurrencySettings from '@/pages/settings/CurrencySettings';
import PolicyManager from '@/pages/settings/PolicyManager';

export const settingsRoutes = (
  <React.Fragment>
    <Route path="settings/attendance" element={<AttendanceSettings />} />
    <Route path="settings/timezone" element={<TimezoneSettings />} />
    <Route path="settings/currency" element={<CurrencySettings />} />
    <Route path="settings/payment-gateway" element={<TenantPaymentGateway />} />
    <Route path="settings/sms" element={<SMSSettings />} />
    <Route path="settings/whatsapp" element={<WhatsAppSettings />} />
    <Route path="settings/college" element={<CollegeSettings />} />
    <Route path="settings/withdrawal-policy" element={<WithdrawalPolicySettings />} />
    <Route path="settings/data-migration" element={<DataMigration />} />
    <Route path="settings/policies" element={<PolicyManager />} />
    <Route path="admin/email-settings" element={<EmailSettings />} />
    <Route path="admin/data-reset" element={<DataResetPage />} />
  </React.Fragment>
);
